import { render } from "./ColleagueDepartmentDetails.vue?vue&type=template&id=80ae518c&scoped=true"
import script from "./ColleagueDepartmentDetails.vue?vue&type=script&lang=js"
export * from "./ColleagueDepartmentDetails.vue?vue&type=script&lang=js"

import "./ColleagueDepartmentDetails.vue?vue&type=style&index=0&id=80ae518c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ae518c"]])

export default __exports__